import { Button } from '@tablecheck/tablekit-react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';

import { AuthFormWrapper } from 'utils/form.styles';

export function FailedPage(): JSX.Element {
  const [t, { language }] = useTranslation();
  const { search } = useLocation();
  const history = useHistory();

  return (
    <AuthFormWrapper>
      <h2>{t('errors.login_failed')}</h2>
      <Button
        data-size="large"
        onClick={() => {
          history.push(`/${language}${search}`);
        }}
      >
        {t('forms.try_again')}
      </Button>
    </AuthFormWrapper>
  );
}
